"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[62736],{

/***/ 62736:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ blog; },
  "nB": function() { return /* binding */ useGetArticleQuery; },
  "rh": function() { return /* binding */ useGetArticlesListQuery; },
  "$D": function() { return /* binding */ useGetArticlesRelatedToPersonQuery; },
  "M9": function() { return /* binding */ useGetDraftArticleQuery; },
  "i1": function() { return /* binding */ useGetSearchResultQuery; }
});

// UNUSED EXPORTS: useGetRelatedArticlesQuery, useGetTagsQuery

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/lodash/uniqWith.js
var uniqWith = __webpack_require__(87185);
var uniqWith_default = /*#__PURE__*/__webpack_require__.n(uniqWith);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
;// CONCATENATED MODULE: ./utils/contentful/graphqlQuery.js

function getParam(params) {
    if (params && !isEmpty_default()(params)) {
        var param = Object.entries(params)[0];
        return param[1] ? "".concat(param[0], ": ").concat(param[1], " ,") : "";
    }
    return "";
}
var queryfy = function(obj) {
    if (typeof obj === "number" || typeof obj === "boolean") {
        return obj;
    }
    if (Array.isArray(obj)) {
        var props = obj.map(function(value) {
            return "".concat(queryfy(value));
        }).join(",");
        return "[".concat(props, "]");
    }
    if (typeof obj === "object") {
        var props1 = Object.keys(obj).map(function(key) {
            return "".concat(key, ":").concat(queryfy(obj[key]));
        }).join(",");
        return "{".concat(props1, "}");
    }
    return JSON.stringify(obj);
};
function getFilterParams(obj) {
    if (isEmpty_default()(obj)) {
        return "where: {}";
    }
    return "where: ".concat(queryfy(obj));
}
var GRAPHQL_QUERY = {
    loadTag: function loadTag(param) {
        var order = param.order, where = param.where;
        return "\n      query {\n        tagCollection(\n          ".concat(getParam({
            order: order
        }), "\n          ").concat(getFilterParams(where), "\n        ) {\n          items {\n            slug\n            title\n            type\n            description\n          }\n        }\n      }\n    ");
    },
    loadPreviewArticles: function loadPreviewArticles(param) {
        var limit = param.limit, order = param.order, skip = param.skip, where = param.where;
        return "\n      query {\n        articleCollection(\n          ".concat(getParam({
            limit: limit
        }), "\n          ").concat(getParam({
            order: order
        }), "\n          ").concat(getParam({
            skip: skip
        }), "\n          ").concat(getFilterParams(where), "\n        ) {\n          total\n          items {\n            title\n            slug\n            previewImageUrl {\n              url\n            }\n            tagsListCollection {\n              items {\n                slug\n              }\n            }\n            introduction\n            publishedAt\n          }\n        }\n      }\n    ");
    },
    getNearbyArticle: function getNearbyArticle(param) {
        var limit = param.limit, order = param.order, where = param.where;
        return "\n      query {\n        articleCollection(\n          ".concat(getParam({
            limit: limit
        }), "\n          ").concat(getParam({
            order: order
        }), "\n          ").concat(getFilterParams(where), "\n        ) {\n          items {\n            title\n            slug\n            tagsListCollection {\n              items {\n                slug\n              }\n            }\n            previewImageUrl {\n              url\n            }\n          }\n        }\n      }\n    ");
    },
    getRelatedArticles: function getRelatedArticles(param) {
        var limit = param.limit, where = param.where;
        return "\n      query {\n        tagCollection(\n          ".concat(getFilterParams(where), "\n        ) {\n          items {\n            linkedFrom {\n              articleCollection(\n                ").concat(getParam({
            limit: limit
        }), "\n              ) {\n                items {\n                  title\n                  slug\n                  previewImageUrl {\n                    url\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    ");
    },
    loadPreviewArticlesByTags: function loadPreviewArticlesByTags(param) {
        var limit = param.limit, skip = param.skip, order = param.order, where = param.where;
        return "\n      query {\n        tagCollection(\n          ".concat(getFilterParams(where), "\n          ) {\n            items {\n              slug\n              linkedFrom {\n                articleCollection(\n                  ").concat(getParam({
            limit: limit
        }), "\n                  ").concat(getParam({
            skip: skip
        }), "\n                  ").concat(getParam({
            order: order
        }), "\n              ) {\n                total\n                items {\n                  title\n                  slug\n                  previewImageUrl {\n                    url\n                  }\n                  introduction\n                  publishedAt\n                }\n              }\n            }\n          }\n        }\n      }\n    ");
    }
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var lodash_get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(lodash_get);
// EXTERNAL MODULE: ./utils/contentful/client.js + 67 modules
var client = __webpack_require__(99308);
;// CONCATENATED MODULE: ./utils/contentful/helper.js






var fetchContentfulArticles = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(isPreviewMode, additionalQuery) {
        var params, options, _tmp, error;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    params = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : {};
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        ,
                        7
                    ]);
                    options = (0,_object_spread/* default */.Z)({
                        contentType: "article",
                        additionalQueryParams: (0,_object_spread/* default */.Z)({}, additionalQuery)
                    }, params);
                    if (!isPreviewMode) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        client/* contentfulPreviewClient.getEntries */.E4.getEntries(options)
                    ];
                case 2:
                    _tmp = _state.sent();
                    return [
                        3,
                        5
                    ];
                case 3:
                    return [
                        4,
                        client/* contentfulClient.getEntries */.gc.getEntries(options)
                    ];
                case 4:
                    _tmp = _state.sent();
                    _state.label = 5;
                case 5:
                    return [
                        2,
                        _tmp
                    ];
                case 6:
                    error = _state.sent();
                    console.error("Fetch error of articles", error);
                    return [
                        3,
                        7
                    ];
                case 7:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchContentfulArticles(isPreviewMode, additionalQuery) {
        return _ref.apply(this, arguments);
    };
}();
var findArticlesByValue = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(value) {
        var field, items, err;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    field = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : "keyWords";
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        fetchContentfulArticles((0,_define_property/* default */.Z)({}, "fields.".concat(field, "[match]"), value))
                    ];
                case 2:
                    items = _state.sent().items;
                    return [
                        2,
                        items
                    ];
                case 3:
                    err = _state.sent();
                    console.error("The error catched from finding articles: ");
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function findArticlesByValue(value) {
        return _ref.apply(this, arguments);
    };
}();
var getGraphqlResultTags = function(graphqlResult) {
    return get_default()(graphqlResult, "tagCollection.items", []);
};
var getGraphqlResultWorkTypes = function(graphqlResult) {
    return get(graphqlResult, "workTypeCollection.items", []);
};
function getGraphqlResultArticles(graphqlResult) {
    return get_default()(graphqlResult, "articleCollection.items", []);
}
function getGraphqlResultTotalArticlesCount(graphqlResult) {
    return get_default()(graphqlResult, "articleCollection.total", []);
}
function getGraphqlResultArticlesByTags(graphqlResult) {
    var result = get_default()(graphqlResult, "tagCollection.items[0].linkedFrom.articleCollection.items", []);
    result.forEach(function(item) {
        item.tagsListCollection = {
            items: [
                {
                    slug: get_default()(graphqlResult, "tagCollection.items[0].slug", [])
                }
            ]
        };
    });
    return result;
}
function getGraphqlResultTotalArticlesCountByTags(graphqlResult) {
    return get_default()(graphqlResult, "tagCollection.items[0].linkedFrom.articleCollection.total", []);
}

// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(6572);
// EXTERNAL MODULE: ./utils/constants.js
var constants = __webpack_require__(96076);
// EXTERNAL MODULE: ./utils/error.js
var error = __webpack_require__(93250);
// EXTERNAL MODULE: ./redux/apis/index.js
var apis = __webpack_require__(91555);
;// CONCATENATED MODULE: ./redux/apis/blog.js












var blogApi = apis["default"].injectEndpoints({
    endpoints: function(builder) {
        return {
            getArticlesList: builder.query({
                extraOptions: {
                    client: client/* blogClient */.DM,
                    type: apis.BASEQUERY_TYPES.graphql
                },
                query: function query(param) {
                    var slug = param.slug, skip = param.skip, limit = param.limit, _isTag = param.isTag, isTag = _isTag === void 0 ? false : _isTag, _order = param.order, order = _order === void 0 ? "[publishedAt_DESC]" : _order;
                    return isTag ? GRAPHQL_QUERY.loadPreviewArticlesByTags({
                        limit: limit,
                        skip: skip,
                        order: order,
                        where: {
                            slug: slug
                        }
                    }) : GRAPHQL_QUERY.loadPreviewArticles({
                        skip: skip,
                        limit: limit,
                        order: order
                    });
                },
                transformResponse: function transformResponse(response, _, param) {
                    var isTag = param.isTag;
                    return {
                        items: isTag ? getGraphqlResultArticlesByTags(response) : getGraphqlResultArticles(response),
                        total: isTag ? getGraphqlResultTotalArticlesCountByTags(response) : getGraphqlResultTotalArticlesCount(response)
                    };
                }
            }),
            getArticlesRelatedToPerson: builder.query({
                extraOptions: {
                    client: client/* blogClient */.DM,
                    type: apis.BASEQUERY_TYPES.getEntries
                },
                query: function query(param) {
                    var id = param.id, skip = param.skip, limit = param.limit;
                    return {
                        contentType: "article",
                        additionalQueryParams: {
                            links_to_entry: id,
                            order: "-fields.publishedAt",
                            skip: skip,
                            limit: limit
                        }
                    };
                },
                transformResponse: function transformResponse(response) {
                    return {
                        items: response.items,
                        total: response.total
                    };
                }
            }),
            getTags: builder.query({
                extraOptions: {
                    client: client/* blogClient */.DM,
                    type: apis.BASEQUERY_TYPES.graphql
                },
                query: function query() {
                    return GRAPHQL_QUERY.loadTag({});
                },
                transformResponse: function transformResponse(response) {
                    return getGraphqlResultTags(response);
                }
            }),
            getArticle: builder.query({
                extraOptions: {
                    client: client/* blogClient */.DM,
                    type: apis.BASEQUERY_TYPES.getEntries
                },
                queryFn: function queryFn(param, _, __, baseQuery) {
                    var slug = param.slug;
                    return (0,_async_to_generator/* default */.Z)(function() {
                        var ref, ref1, ref2, ref3, ref4, article, ref5, publishedAt, tagsList, ref6, next, prev, related, e;
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    _state.trys.push([
                                        0,
                                        3,
                                        ,
                                        4
                                    ]);
                                    if (!slug) {
                                        return [
                                            2,
                                            {
                                                error: "Wrong argument"
                                            }
                                        ];
                                    }
                                    return [
                                        4,
                                        baseQuery({
                                            contentType: "article",
                                            query: {
                                                slug: slug
                                            }
                                        })
                                    ];
                                case 1:
                                    article = (ref = _state.sent()) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.items) === null || ref2 === void 0 ? void 0 : ref2[0];
                                    ref5 = (0,helper/* getDocumentFields */.OA)(article, [
                                        "tagsList",
                                        "publishedAt"
                                    ]), publishedAt = ref5.publishedAt, tagsList = ref5.tagsList;
                                    return [
                                        4,
                                        Promise.all([
                                            client/* blogClient.graphql */.DM.graphql(GRAPHQL_QUERY.getNearbyArticle({
                                                limit: 1,
                                                order: "[publishedAt_DESC]",
                                                where: {
                                                    publishedAt_lt: publishedAt
                                                }
                                            })),
                                            client/* blogClient.graphql */.DM.graphql(GRAPHQL_QUERY.getNearbyArticle({
                                                limit: 1,
                                                order: "[publishedAt_DESC]",
                                                where: {
                                                    publishedAt_gt: publishedAt
                                                }
                                            })),
                                            client/* blogClient.graphql */.DM.graphql(GRAPHQL_QUERY.getRelatedArticles({
                                                limit: 10,
                                                where: {
                                                    slug: tagsList[0].fields.slug
                                                }
                                            }))
                                        ])
                                    ];
                                case 2:
                                    ref6 = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                                        _state.sent(),
                                        3
                                    ]), next = ref6[0], prev = ref6[1], related = ref6[2];
                                    return [
                                        2,
                                        {
                                            data: {
                                                article: article,
                                                next: ((ref3 = getGraphqlResultArticles(next)) === null || ref3 === void 0 ? void 0 : ref3[0]) || {},
                                                prev: ((ref4 = getGraphqlResultArticles(prev)) === null || ref4 === void 0 ? void 0 : ref4[0]) || {},
                                                related: getGraphqlResultArticlesByTags(related)
                                            }
                                        }
                                    ];
                                case 3:
                                    e = _state.sent();
                                    console.log(e, "-------------");
                                    return [
                                        3,
                                        4
                                    ];
                                case 4:
                                    return [
                                        2
                                    ];
                            }
                        });
                    })();
                }
            }),
            getDraftArticle: builder.query({
                extraOptions: {
                    client: client/* blogPreviewClient */.HH,
                    type: apis.BASEQUERY_TYPES.getEntries
                },
                query: function query(slug) {
                    return {
                        contentType: "article",
                        query: {
                            slug: slug
                        }
                    };
                },
                transformResponse: function transformResponse(response) {
                    return response.items[0];
                }
            }),
            getSearchResult: builder.query({
                extraOptions: {
                    client: client/* blogClient */.DM,
                    type: apis.BASEQUERY_TYPES.graphql
                },
                queryFn: function queryFn(value, _, __, baseQuery) {
                    return (0,_async_to_generator/* default */.Z)(function() {
                        var ref, byTagRaw, byText, result, e;
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    if (!value) {
                                        return [
                                            2,
                                            {
                                                data: []
                                            }
                                        ];
                                    }
                                    _state.label = 1;
                                case 1:
                                    _state.trys.push([
                                        1,
                                        3,
                                        ,
                                        4
                                    ]);
                                    return [
                                        4,
                                        Promise.all([
                                            baseQuery(GRAPHQL_QUERY.loadPreviewArticlesByTags({
                                                where: {
                                                    title_contains: value
                                                },
                                                limit: constants/* SEARCH_ARTICLES_LIMIT */.WV
                                            })),
                                            baseQuery(GRAPHQL_QUERY.loadPreviewArticles({
                                                order: "[publishedAt_DESC]",
                                                limit: constants/* SEARCH_ARTICLES_LIMIT */.WV,
                                                where: {
                                                    OR: [
                                                        {
                                                            title_contains: value
                                                        },
                                                        {
                                                            oldBody_contains: value
                                                        },
                                                        {
                                                            title_contains: value
                                                        }
                                                    ]
                                                }
                                            }))
                                        ])
                                    ];
                                case 2:
                                    ref = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                                        _state.sent(),
                                        2
                                    ]), byTagRaw = ref[0], byText = ref[1];
                                    result = uniqWith_default()((0,_to_consumable_array/* default */.Z)(getGraphqlResultArticlesByTags(byTagRaw.data)).concat((0,_to_consumable_array/* default */.Z)(getGraphqlResultArticles(byText.data))), function(article1, article2) {
                                        return article1.slug === article2.slug;
                                    }).sort(function(a, b) {
                                        return Date.parse(a) - Date.parse(b);
                                    });
                                    return [
                                        2,
                                        {
                                            data: result
                                        }
                                    ];
                                case 3:
                                    e = _state.sent();
                                    (0,error/* handleError */.S3)(e);
                                    return [
                                        2,
                                        {
                                            error: e.message
                                        }
                                    ];
                                case 4:
                                    return [
                                        2
                                    ];
                            }
                        });
                    })();
                }
            })
        };
    }
});
var useGetArticlesListQuery = blogApi.useGetArticlesListQuery, useGetTagsQuery = blogApi.useGetTagsQuery, useGetArticleQuery = blogApi.useGetArticleQuery, useGetSearchResultQuery = blogApi.useGetSearchResultQuery, useGetDraftArticleQuery = blogApi.useGetDraftArticleQuery, useGetRelatedArticlesQuery = blogApi.useGetRelatedArticlesQuery, useGetArticlesRelatedToPersonQuery = blogApi.useGetArticlesRelatedToPersonQuery;
/* harmony default export */ var blog = (blogApi);


/***/ })

}]);